// 기본 배송 설정 섹션 URL (2026-08-24 KST 추가)
const shippingSettingsSection = "/shipping-settings";

export const shippingSettingsPath = shippingSettingsSection;
